/*-----------Types of Users actions--------*/

/*---SAVE----*/
export const USER_SAVE_SUCCESS = "USER_SAVE_SUCCESS";
export const USER_SAVE_FAILED = "USER_SAVE_FAILED";
export const USER_IS_SAVING = "USER_IS_SAVING";

/*---FETCH----*/
export const USER_FETCH_SUCCESS = "USER_FETCH_SUCCESS";
export const USER_FETCH_FAILED = "USER_FETCH_FAILED";
export const USER_IS_FETCHING = "USER_IS_FETCHING";
export const ONE_USER_FETCH_SUCCESS = "ONE_USER_FETCH_SUCCESS";
export const VERIFY_USER = "VERIFY_USER";

/*---UPDATE----*/
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAILED = "USER_UPDATE_FAILED";
export const USER_IS_UPDATING = "USER_IS_UPDATING";

/*---PATCH----*/
export const USER_PATCH_SUCCESS = "USER_PATCH_SUCCESS";
export const USER_PATCH_FAILED = "USER_PATCH_FAILED";
export const USER_IS_PATCHING = "USER_IS_PATCHING";

/*---DELETE----*/
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_FAILED = "USER_DELETE_FAILED";
export const USER_IS_DELETING = "USER_IS_DELETING";

/*---SEARCH----*/
export const USER_SEARCH = "USER_SEARCH";

/*---PDF USERS----*/
export const USER_PDF = "USER_PDF";
